import { Typography } from "@material-ui/core";
import { styled } from "@material-ui/core/styles";

const GreyText = styled(Typography)(({ theme }) => ({
  fontFamily: theme.typography.interFontStack,
  color: theme.palette.grey[900],
}));

export default GreyText;
